import moment from 'moment';

export const formatDate = dateString => {
  if (!dateString) return 'N/A';

  const date = moment(dateString);
  if (!date.isValid()) return 'N/A';

  return date.format('DD MMMM YYYY');
};

export const formatDateAndTime = dateString => {
  if (!dateString) return 'N/A';

  const date = moment(dateString);
  if (!date.isValid()) return 'N/A';

  return date.format('DD MMMM YYYY, h:mm A');
};

export const formatYear = dateString => {
  if (!dateString) return 'N/A';

  const date = moment(dateString);
  if (!date.isValid()) return 'N/A';

  return date.format('YYYY');
};

export const formatTimeAgo = dateString => {
  if (!dateString) return 'N/A';

  const date = moment(dateString);
  if (!date.isValid()) return 'N/A';

  return date.fromNow();
};

export const formatShortDate = dateString => {
  if (!dateString) return 'N/A';

  const date = moment(dateString);
  if (!date.isValid()) return 'N/A';

  return date.format('DD/MM/YY');
};

export const getEndDate = startDate => {
  return moment(startDate).add(1, 'month').toDate();
};

export const getDuration = (startDate, endDate) => {
  const today = moment().startOf('day');
  const start = moment(startDate).startOf('day');
  const end = moment(endDate).startOf('day');

  if (today.isBefore(start)) {
    return end.diff(start, 'days') + ' days';
  } else if (today.isBetween(start, end)) {
    return end.diff(today, 'days') + ' days remaining';
  } else {
    return 'Expired';
  }
};
